var depth = {
  1: {
    default: "0 0 2px 0 rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.14)"
  },
  2: {
    default: "0 3px 3px 0 rgba(0, 0, 0, 0.1), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 1px 8px 0 rgba(0, 0, 0, 0.14)",
    focusRing: "0 3px 8px 0 rgba(0, 0, 0, 0.14), 0 5px 4px 0 rgba(0, 0, 0, 0.12), 0 5px 3px 0 rgba(0, 0, 0, 0.1)"
  },
  3: {
    default: "0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px 0 rgba(0, 0, 0, 0.14)"
  },
  4: {
    default: "0 12px 17px 2px rgba(0, 0, 0, 0.1), 0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 7px 8px 0 rgba(0, 0, 0, 0.14)"
  }
};
function getDepth(level, type) {
  var _depth$level;
  var depthType = type !== null && type !== void 0 ? type : 'default';
  return depth === null || depth === void 0 ? void 0 : (_depth$level = depth[level]) === null || _depth$level === void 0 ? void 0 : _depth$level[depthType];
}
export { getDepth as default };